/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Counts_RuleInputs */

const en_us2_clubs_counts_rule = /** @type {(inputs: Clubs_Counts_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A workout counts when it's logged in the app, ended, with at least 3 sets and 10 minutes. Imported workouts don't count.`)
};

const pt_br2_clubs_counts_rule = /** @type {(inputs: Clubs_Counts_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta o treino registrado no app, encerrado, com pelo menos 3 séries e 10 minutos. Treino importado não conta.`)
};

const es_419_clubs_counts_rule = /** @type {(inputs: Clubs_Counts_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un entrenamiento cuenta si se registró en la app, se terminó y tiene al menos 3 series y 10 minutos. Los importados no cuentan.`)
};

const pt_pt2_clubs_counts_rule = /** @type {(inputs: Clubs_Counts_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta o treino registado na app, terminado, com pelo menos 3 séries e 10 minutos. Treinos importados não contam.`)
};

const fr_fr2_clubs_counts_rule = /** @type {(inputs: Clubs_Counts_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une séance compte si elle est enregistrée dans l'appli et terminée, avec au moins 3 séries et 10 minutes. Les séances importées ne comptent pas.`)
};

const de_de2_clubs_counts_rule = /** @type {(inputs: Clubs_Counts_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Training zählt, wenn es in der App erfasst und beendet ist, mit mindestens 3 Sätzen und 10 Minuten. Importierte Trainings zählen nicht.`)
};

const it_it2_clubs_counts_rule = /** @type {(inputs: Clubs_Counts_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un allenamento conta se registrato nell'app, concluso, con almeno 3 serie e 10 minuti. Gli allenamenti importati non contano.`)
};

/**
* | output |
* | --- |
* | "A workout counts when it's logged in the app, ended, with at least 3 sets and 10 minutes. Imported workouts don't count." |
*
* @param {Clubs_Counts_RuleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_counts_rule = /** @type {((inputs?: Clubs_Counts_RuleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Counts_RuleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_counts_rule(inputs)
	if (locale === "es-419") return es_419_clubs_counts_rule(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_counts_rule(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_counts_rule(inputs)
	if (locale === "de-DE") return de_de2_clubs_counts_rule(inputs)
	if (locale === "it-IT") return it_it2_clubs_counts_rule(inputs)
	return en_us2_clubs_counts_rule(inputs)
});
export { clubs_counts_rule as "clubs.counts_rule" }